import {useIsOverviewEnabled} from '../hooks/use-feature-state'
import {RailsPartial} from '@github-ui/rails-partial'
import {pullRequestsChecksRoute} from './checks-route'
import styles from './Checks.module.css'
import {clsx} from 'clsx'

export function ChecksEntrypoint() {
  const updatedHeader = useIsOverviewEnabled()
  return (
    <div className={clsx(styles.checksRoot, updatedHeader && styles.constrainedContent, updatedHeader && 'tmp-pb-3')}>
      <RailsPartial partialName="Main" route={pullRequestsChecksRoute} />
    </div>
  )
}
